<template>
  <div class="report">
    <div class="row">
      <div class="col-12">
        <div class="mt-2">
          <router-link class="btn btn-secondary mr-2" to="/dashboard">Back</router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <div class="mt-4">
          <label>Year:</label>
        </div>
        <div>
          <select class="form-control" v-model="year">
            <option v-for="year in years" :value="year" :key="year">{{ year }}</option>
          </select>
        </div>
        <div class="mt-4">
          <button class="btn btn-block btn-primary" @click.prevent="getReport">Submit</button>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 table-responsive">
        <table class="table table-striped table-report">
          <thead>
            <tr>
              <th class="text-center"></th>
              <th class="text-center" colspan="3">Back Log</th>
              <th class="text-center" colspan="3">End of Period Acting</th>
              <th class="text-center" colspan="4"></th>
            </tr>
            <tr>
              <th class="text-center">Month</th>
              <th class="text-center">New Contact</th>
              <th class="text-center">Answer</th>
              <th class="text-center">Not Late (&lt; 1 min)</th>
              <th class="text-center">Late (1 - 3 min)</th>
              <th class="text-center">Super Late (&gt; 3 min)</th>
              <th class="text-center">ASA</th>
              <th class="text-center">(s)</th>
              <th class="text-center">ASR</th>
              <th class="text-center">(s)</th>
              <th class="text-center">AHT</th>
              <th class="text-center">(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in report" :key="index">
              <td class="text-center">{{ months[index].shortNameEn }}</td>
              <td class="text-center">{{ item.new | formatNumber }}</td>
              <td class="text-center">{{ item.answer | formatNumber }}</td>
              <td class="text-center">{{ item.not_late | formatNumber }}</td>
              <td class="text-center">{{ item.late | formatNumber }}</td>
              <td class="text-center">{{ item.super_late | formatNumber }}</td>
              <td class="text-center">
                <template v-if="getAverageASA(item)">
                  {{ getAverageASA(item)}}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASA(item)">
                  {{ getAverageASA(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASR(item)">
                  {{ getAverageASR(item)}}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASR(item)">
                  {{ getAverageASR(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
               <template v-if="getAverageAHT(item)">
                  {{ getAverageAHT(item) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
               <template v-if="getAverageAHT(item)">
                  {{ getAverageAHT(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      report: [],
      year: moment().year(),
      months: [
        { name: 'มกราคม', shortName: 'ม.ค.', shortNameEn: 'Jan', nameEn: 'January', month: 1 },
        { name: 'กุมภาพันธ์', shortName: 'ก.พ.', shortNameEn: 'Feb', nameEn: 'February', month: 2 },
        { name: 'มีนาคม', shortName: 'มี.ค.', shortNameEn: 'Mar', nameEn: 'Mar', month: 3 },
        { name: 'เมษายน', shortName: 'เม.ย.', shortNameEn: 'Apr', nameEn: 'April', month: 4 },
        { name: 'พฤษภาคม', shortName: 'พ.ค.', shortNameEn: 'May', nameEn: 'May', month: 5 },
        { name: 'มิถุนายน', shortName: 'มิ.ย.', shortNameEn: 'Jun', nameEn: 'June', month: 6 },
        { name: 'กรกฎาคม', shortName: 'ก.ค.', shortNameEn: 'Jul', nameEn: 'July', month: 7 },
        { name: 'สิงหาคม', shortName: 'ส.ค.', shortNameEn: 'Aug', nameEn: 'August', month: 8 },
        { name: 'กันยายน', shortName: 'ก.ย.', shortNameEn: 'Sep', nameEn: 'September', month: 9 },
        { name: 'ตุลาคม', shortName: 'ต.ค.', shortNameEn: 'Oct', nameEn: 'October', month: 10 },
        { name: 'พฤศจิกายน', shortName: 'พ.ย.', shortNameEn: 'Nov', nameEn: 'November', month: 11 },
        { name: 'ธันวาคม', shortName: 'ธ.ค.', shortNameEn: 'Dec', nameEn: 'December', month: 12 }
      ]
    }
  },
  computed: {
    ...mapState('admin', ['admin']),
    years () {
      let start = 2021
      let end = moment().year() + 1
      return Array(end - start).fill().map((d, i) => i + start)
    }
  },
  filters: {
    formatNumber: value => {
      if (value) {
        if (Math.abs(Number(value)) < 0.01) {
          return '0'
        }
        return Number(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return '0'
    }
  },
  methods: {
    getAverageASA (item, format = '') {
      if (!item.asa_count || !item.asa_sum) {
        return null
      }
      let s = item.asa_sum / item.asa_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    getAverageASR (item, format = '') {
      if (!item.asr_count || !item.asr_sum) {
        return null
      }
      let s = item.asr_sum / item.asr_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    getAverageAHT (item, format = '') {
      if (!item.aht_count || !item.aht_sum) {
        return null
      }
      let s = item.aht_sum / item.aht_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    formatDuration (s) {
      let h = 0
      let m = 0
      if (s > 60) {
        m = Math.floor(s / 60)
        s = Math.floor(s - (m * 60))
      }
      if (m > 60) {
        h = Math.floor(m / 60)
        m = m - (h * 60)
      }
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    async getReport () {
      let queryParams = { year: this.year }
      if (this.$route.query.customer_type) {
        queryParams.customer_type = this.$route.query.customer_type
      }
      const res = await axios.get('reports/monthly', { params: queryParams })
      if (res.status === 200) {
        this.report = res.data.report ? res.data.report : []
      } else {
        this.report = []
      }
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>

<style lang="scss" scoped>
.report {
  padding: 1rem;
}
.table-report {
  font-size: 80%;
}
</style>
